const EMAIL_LOCAL_STORAGE_KEY = "ipmobEmails";

const FOP = {
    suffix: '/p/fop',
    query: {
        redirect: 'qc'
    }
};

const WEBFORM = {
    prefix: '/p/pm-intake'
};

const LOCALES = {
    fr: 'fr_FR'
}

const BASIC_INFO_LOCAL_STORAGE_KEY = "userBasicInfo";

const CURRENCY_LOCAL_STORAGE_KEY = "userCurrency";

const ADDRESS_TYPE_MAILING = 'mailing';

const ADDRESS_TYPE_BILLING = 'billing';

const PROPERTY_OFFER_TYPE = {
    commercialOfferType: 'Performance - 2',
    defaultOfferType: 'PPB'
};

const MERCHANT_OF_RECORD = {
    SUPPLIER: 'SUPPLIER',
    EG: 'EG',
    UNSPECIFIED: 'UNSPECIFIED'
};

const PC_ELIGIBILITY_INFO = {
    ipm: {
        homeaway_us: {
            propertyCount: 0
        },
        other: {
            propertyCount: 0
        }
    },
    ppm: {
        propertyCount: 0
    }
};

const MAX_COL_SIZE = 5;

const BRAND_NAME = {
    vrbo: 'Vrbo',
    abritel: 'Abritel.fr',
    fewo: 'FeWo-direkt.de'
}

const CAS_BRAND_PATH = {
    homeaway_us: 'homeaway',
    vrbo: 'vrbo',
    odhr: 'odhr',
    vr: 'vr',
    abritel: 'abritel',
    homeaway_at: 'haat',
    homeaway_au: 'haau',
    homeaway_de: 'fewo',
    homeaway_dk: 'hadk',
    homeaway_es: 'haes',
    homelidays_es: 'hdes',
    homelidays_fr: 'hdfr',
    homeaway_it: 'hait',
    homelidays_it: 'hdit',
    homeaway_lk: 'halk',
    homeaway_nl: 'hanl',
    homeaway_nz: 'hanz',
    homeaway_no: 'hano',
    homeaway_pt: 'hapt',
    homeaway_se: 'hase',
    homeaway_uk: 'hr',
    homeaway_br: 'habr',
    homeaway_sg: 'hasg',
    homeaway_jp: 'hajp'
};

const BILLING_ERROR_LOCAL_STORAGE_KEY = 'billingSubmitErrorAttempt';

const BILLING = 'BILLING';

const CONTACT = 'CONTACT';

const SHIPPING = 'SHIPPING';

const BILLING_ERROR_MAX_ATTEMPT = 3;

const QUEBEC_COUNTRY_CODE = 'CA';

const QUEBEC_STATE_CODE = 'QC';

const ASTERISK = '*';

const CONTACT_PHONE_NUMBER = '(888) 581-1849';

const BUSINESS_TYPE = {
    PLC: 'Public limited company',
    PVTLC: 'Private limited company',
    PO: 'Private Owner'
};

const PHONE_DENY_LIST = ['18772392592','4969257378892','442035145512','33413681044','34911238313','390694802125','351308804358','1800662594','61280152783','099097879','6498011377','0345894868','81345894868','6531587742','60392125460','622127899769','85258082655','66600024196','6322711692','886255924054','18772024291','18772283145','15127820805','528005630687','15038214261','08000300331','551147002359','448000325622','460201604695','45089882795','900031108','34911238309','330413680288','4906980884172','430800706296','800793675','390680335207','800210539','310202629300','3080044149866','1800662594','61291654531','0800005604','6498011377','6566227363','60377249656','85258082655','622127899745','6627873011','180087989968','886255924054','82234833305','81345789669'];

const FLAG_IMAGE_URL_MAP = {
    'vrbo': 'https://a.travel-assets.com/egds/marks/flags/us.svg',
    'homeaway_us': 'https://a.travel-assets.com/egds/marks/us.svg',
    'homeaway_uk': 'https://a.travel-assets.com/egds/marks/flags/uk.svg',
    'abritel': 'https://a.travel-assets.com/egds/marks/flags/fr.svg',
    'homeaway_it': 'https://a.travel-assets.com/egds/marks/flags/it.svg',
    'homeaway_es': 'https://a.travel-assets.com/egds/marks/flags/es.svg',
    'homeaway_pt': 'https://a.travel-assets.com/egds/marks/flags/pt.svg',
    'homeaway_de': 'https://a.travel-assets.com/egds/marks/flags/de.svg',
    'homeaway_au': 'https://a.travel-assets.com/egds/marks/flags/au.svg',
    'homeaway_nz': 'https://a.travel-assets.com/egds/marks/flags/nz.svg'
};

const BRAND_IMAGE_URL_MAP = {
    'abritel': 'https://a.travel-assets.com/egds/marks/onekey__abritel.svg',
    'homeaway_de': 'https://a.travel-assets.com/egds/marks/onekey__fewodirekt.svg'
};

const DEFAULT_BRAND_IMAGE_URL = 'https://a.travel-assets.com/egds/marks/vrbo.svg';

const CURRENCY_SYMBOLS_MAP = {
    USD: '($)',
    CAD: '($)',
    NZD: '($)',
    AUD: '($)',
    EUR: '(€)',
    GBP: '(£)'
};

const SSO_UNSUPPORTED_SITES_LIST = [
    'homeaway_cafr',
    'homeaway_ca',
    'homeaway_at',
    'homeaway_sg',
    'homeaway_no',
    'homeaway_se',
    'homeaway_dk',
    'homeaway_gr',
    'homeaway_nl',
    'homeaway_mx',
    'homeaway_jp',
    'homeaway_br'
];

const ONBOARD_ADVERTISER_SYSTEM_ID_WHITELIST = [
    "GUESTY",
    "HOSTAWAY",
    "ITRIP",
    "IT_SOLUTIONS",
    "KROSSBOOKING",
    "LODGIFY",
    "NEXTPAX",
    "RESLY",
    "STAAH"
];

const getFlagImageUrl = (siteName) => {
    return FLAG_IMAGE_URL_MAP[siteName] || '';
};

const getBrandImageUrl = (siteName) => {
    return BRAND_IMAGE_URL_MAP[siteName] || DEFAULT_BRAND_IMAGE_URL;
};

const getCurrencySymbol = (currency) => {
    return CURRENCY_SYMBOLS_MAP[currency] || '';
};


export {
    EMAIL_LOCAL_STORAGE_KEY,
    PROPERTY_OFFER_TYPE,
    PC_ELIGIBILITY_INFO,
    BRAND_NAME,
    CAS_BRAND_PATH,
    FOP,
    LOCALES,
    BASIC_INFO_LOCAL_STORAGE_KEY,
    CURRENCY_LOCAL_STORAGE_KEY,
    ADDRESS_TYPE_MAILING,
    ADDRESS_TYPE_BILLING,
    BILLING_ERROR_LOCAL_STORAGE_KEY,
    BILLING_ERROR_MAX_ATTEMPT,
    QUEBEC_COUNTRY_CODE,
    QUEBEC_STATE_CODE,
    BILLING,
    CONTACT,
    SHIPPING,
    ASTERISK,
    WEBFORM,
    CONTACT_PHONE_NUMBER,
    BUSINESS_TYPE,
    MERCHANT_OF_RECORD,
    PHONE_DENY_LIST,
    getBrandImageUrl,
    getFlagImageUrl,
    getCurrencySymbol,
    BRAND_IMAGE_URL_MAP,
    FLAG_IMAGE_URL_MAP,
    CURRENCY_SYMBOLS_MAP,
    DEFAULT_BRAND_IMAGE_URL,
    MAX_COL_SIZE,
    SSO_UNSUPPORTED_SITES_LIST,
    ONBOARD_ADVERTISER_SYSTEM_ID_WHITELIST
};
